const api = 'https://files.bikiran.com/';

const logoBikiran = 'https://files.bikiran.com/logo.svg';

export const images = { api, logoBikiran };

export default null;
